import { Change, ChangeType, Element } from '@ritabygglov/core';
import { createDeleteChange } from '../services/Actions';
import { Command } from './Command';

export class DeleteCommand implements Command {
  constructor(
    private elements: Element[],
    private userId: string
  ) {}

  isEphemeral = false;

  execute(): Change[] {
    return this.elements
      .map((element) => createDeleteChange(element, this.userId))
      .filter((change): change is Change => change !== null);
  }

  undo(): Change[] {
    return this.elements.map((element) => ({
      createdAt: new Date().toISOString(),
      elementType: element.type,
      object: element,
      changeType: ChangeType.Create,
      ephemeral: false,
    }));
  }
}
